import { isEmpty } from 'lodash/fp';
import React from 'react';

import FeaturesSection, { type FeatureSectionTile } from '../features-section';

type Props = {
  content?: {
    description?: string;
    tiles: FeatureSectionTile[];
    title: string | JSX.Element;
  };
};

const AddOnsSection = ({ content }: Props) => {
  if (isEmpty(content)) {
    return null;
  }

  return <FeaturesSection {...content} withBorder withSimpleBit={false} />;
};

export default AddOnsSection;
